module.exports = __webpack_public_path__ + "media/Goals/FindQuickWins-d07a97bd.svg";